import { Suspense } from "react";
import { useSelector } from "react-redux";
import { appRoutes } from "../utils/routes";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import ThemeLayout from "../components/ThemeLayout";
import Loader from "../components/Loader";
import { PortfolioProvider } from "../contexts/PortfolioContext";
import { canSeeOwnerOnlyFeatures, canSeeTradeDesk } from "../utils/access-control";

const TradeToolGuard = ({ children }) => (
  canSeeOwnerOnlyFeatures() ? children : <Navigate to="/dashboard" replace />
);

const TradeDeskGuard = ({ children }) => (
  canSeeTradeDesk() ? children : <Navigate to="/dashboard" replace />
);

const AppContainer = () => {
  const userId = useSelector((state) => state.public.userSession?.user?.id);
  const MainComponent = appRoutes[0].component;
  
  return (
    <PortfolioProvider userId={userId}>
      <ThemeLayout>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Suspense fallback={<Loader />}>
            <Routes>
              {/* Main routes with nested routes */}
              <Route path="/" element={<MainComponent />}>
                {appRoutes[0].nestedRoutes.map(({ key, path, component: NestedComponent, tradeToolOnly, tradeDeskOnly }) => {
                  const element = tradeDeskOnly ? (
                    <TradeDeskGuard><NestedComponent /></TradeDeskGuard>
                  ) : tradeToolOnly ? (
                    <TradeToolGuard>
                      <NestedComponent />
                    </TradeToolGuard>
                  ) : (
                    <NestedComponent />
                  );
                  if (path === "/") {
                    // Index route for the home path
                    return <Route key={key} index element={element} />;
                  }
                  // Remove leading slash for nested routes
                  const nestedPath = path.replace(/^\//, "");
                  return (
                    <Route key={key} path={nestedPath} element={element} />
                  );
                })}
              </Route>
              
              {/* Standalone routes */}
              {appRoutes.slice(1).map(({ key, path, component: Component }) => (
                <Route key={key} path={path} element={<Component />} />
              ))}
              
              {/* Catch-all route */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </ThemeLayout>
    </PortfolioProvider>
  );
};

export default AppContainer;
